import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell")({
  component: ShellRoute,
});

function ShellRoute() {
  return null;
}
